import { Routes } from '@angular/router';

export const FARM_ROUTES: Routes = [
	{
		path: 'farm',
		loadComponent: () => import('./feature-farm/farm').then((m) => m.Farm),
		data: { title: 'Fazendas' },
	},
];
